import request from "@/utils/request";
import axios from "axios";
import qs from "qs";

// https://yrd-tdh.com:2080/odb
const localApi = "http://172.25.67.189:9528";
const testApi = "https://yrd-tdh.com/sflhd";
const proApi = "http://172.17.4.1:2080/sflhd";

let URL = testApi;

const apiObj = {
  baseUrl: URL,
  api: {
    // 亿通校验
    ytCheck(data) {
      return request({
        url: URL + "/sfl/ytCheck",
        method: "POST",
        data,
      });
    },

    // 获取验证码id
    getPcruuid() {
      return request({
        url: URL + "/sfl/getUUID",
        method: "GET",
      });
    },

    // 根据验证码id获取图片
    getPcrimg(data) {
      return request({
        url: URL + `/sfl/getYzm?${qs.stringify(data)}`,
        method: "GET",
        responseType: "blob", //选择接收方式为blob
      });
    },

    // 获取验证码
    getImgValidateCode() {
      return request({
        url: URL + "/imgValidateCode/getImgValidateCode",
        method: "GET",
      });
    },

    // 获取token
    getImgValidateByKey(data) {
      return request({
        url: URL + "/imgValidateCode/getImgValidateByKey",
        method: "POST",
        data,
      });
    },

    // 上传
    imageUpload(data) {
      // 根据后台需求的数据格式确定headers
      return request({
        url: URL + "/sfl/fileCheck",
        method: "POST",
        data,
      });
    },
  },
};

export default apiObj;



// WEBPACK FOOTER //
// ./src/api/index.js